var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPin009(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8916C10.6569 11.8916 12 10.5485 12 8.8916C12 7.23475 10.6569 5.8916 9 5.8916C7.34315 5.8916 6 7.23475 6 8.8916C6 10.5485 7.34315 11.8916 9 11.8916Z",
    stroke: "#8C8F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.3916C11 17.3916 17 14.8099 17 9.3916C17 4.97332 13.4183 1.3916 9 1.3916C4.58172 1.3916 1 4.97332 1 9.3916C1 14.8099 7 17.3916 9 21.3916Z",
    stroke: "#8C8F93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin009);
export default __webpack_public_path__ + "static/media/marker-pin-009.5927a3506f13c55f14212526a8acd007.svg";
export { ForwardRef as ReactComponent };